import { restApi } from '../../../services/Api'

function getGSVTech(solicitacaoId) {
  return restApi.get(`/solicitacoes/${solicitacaoId}/gsvtech`)
}

function refreshResultadoGSVTech(solicitacaoId) {
  return restApi.get(`/solicitacoes/${solicitacaoId}/gsvtech/refresh`)
}

function recreateGSVTech(solicitacaoId) {
  return restApi.post(`/solicitacoes/${solicitacaoId}/gsvtech/recreate`)
}

const gsvtechRepository = {
  fetch: getGSVTech,
  refreshResult: refreshResultadoGSVTech,
  recreate: recreateGSVTech
}

export default gsvtechRepository
